import type { AbstractControl, ValidationErrors } from '@angular/forms';

/** Allowed: letters (A–Z, a–z), digits (0–9), and spaces. */
export const TRACKING_REFERENCE_ALLOWED_CHARACTERS_REGEX = /^[A-Za-z0-9 ]*$/;

/** Error keys used by tracking reference validators. */
export const TRACKING_REFERENCE_VALIDATION_ERROR_KEYS = {
  restrictedCharacters: 'trackingRestrictedCharacters',
} as const;

/**
 * Returns whether the value contains only allowed characters for tracking references.
 */
export function isAllowedTrackingReferenceText(value: string): boolean {
  return TRACKING_REFERENCE_ALLOWED_CHARACTERS_REGEX.test(value);
}

/**
 * Validates optional tracking references against allowed characters when a value is present.
 * Empty / whitespace-only values are allowed (field is optional).
 * Characters other than letters, digits, and spaces produce trackingRestrictedCharacters.
 */
export function optionalTrackingRestrictedCharactersValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = typeof control.value === 'string' ? control.value.trim() : '';

  if (!value) {
    return null;
  }

  return isAllowedTrackingReferenceText(value)
    ? null
    : { [TRACKING_REFERENCE_VALIDATION_ERROR_KEYS.restrictedCharacters]: true };
}
